import React from 'react';
import styled from 'styled-components';
import { grayShades } from 'styles/abstracts/colors';
import Icon from '_Components/Icons/Icon';
import IrritantsAndEnchantingPointsAIModal from './IrritantsAndEnchantingPointsAIModal';

const StyledCell = styled.td`
  font-weight: bold;
  color: ${grayShades.g800};
  padding: 1.25em 0.75em 0.75em !important;
`;

const IconCell = styled(StyledCell)`
  text-align: center;
`;

const ModalLink = styled.span`
  cursor: pointer;
`;

type ThematicType = {
  thematic: string;
  subThematic: string | null;
  subSubThematic: string | null;
};

type IrritantsAndEnchantingPointsAIRowType = {
  thematic: any;
  verbatimPercentage: string;
  modalTargetId: string;
  isAiAvailable: boolean;
  t: Function;
  thematicAnalyzed: ThematicType;
  irritantsModal: boolean;
  enchantementsModal: boolean;
  setIrritantsModal: Function;
  setEnchantementsModal: Function;
  projectId: number;
  range: {
    startDate: Date;
    endDate: Date;
  };
  handleFetchClick: Function;
  shouldFetch: boolean;
  setShouldFetch: Function;
  thematicMentionCount: number;
  dataId: string | null;
  queryFilters: any;
  setTargetId: Function;
  setTooltipOpen: Function;
};

const IrritantsAndEnchantingPointsAIRow = ({
  thematic,
  verbatimPercentage,
  modalTargetId,
  isAiAvailable,
  t,
  thematicAnalyzed,
  irritantsModal,
  enchantementsModal,
  setIrritantsModal,
  setEnchantementsModal,
  projectId,
  range,
  handleFetchClick,
  shouldFetch,
  setShouldFetch,
  thematicMentionCount,
  dataId,
  queryFilters,
  setTargetId,
  setTooltipOpen,
}: IrritantsAndEnchantingPointsAIRowType) => {
  const handleMouseEnter = (id: string) => {
    setTargetId(id);
    setTooltipOpen(true);
  };
  const getQueryFilters = () => {
    const { thematics } = queryFilters;
    const queryThematics = [
      ...thematics,
      {
        thematic: thematicAnalyzed.thematic,
        subThematic: thematicAnalyzed.subThematic,
        subSubThematic: thematicAnalyzed.subSubThematic,
        joinSpecify: 'and',
      },
    ];

    const filtersForQuery = { ...queryFilters, thematics: queryThematics };
    return filtersForQuery;
  };

  return (
    <>
      <tr>
        <StyledCell>{thematic.thematicsOverviewDetails.name}</StyledCell>
        <IconCell>
          {thematic.thematicsOverviewDetails.absImpactSat !== null
            ? thematic.thematicsOverviewDetails.absImpactSat.toFixed(4)
            : 'N/A'}
        </IconCell>
        <IconCell>{thematic.thematicsOverviewDetails.mentionCount}</IconCell>
        <IconCell>{verbatimPercentage}</IconCell>
        <StyledCell />
        <IconCell>
          <ModalLink
            id={`${modalTargetId}_enchantements`}
            onMouseEnter={() => handleMouseEnter(`${modalTargetId}_enchantements`)}
            onClick={() => {
              handleFetchClick(thematic);
              isAiAvailable && setEnchantementsModal(!enchantementsModal);
            }}
          >
            <Icon className={!isAiAvailable ? 'disabledIcon' : undefined} icon="SUN" size={28} color="#8bdb00" />
          </ModalLink>
          {enchantementsModal && dataId === thematic?.thematicsOverviewDetails?.name && (
            <IrritantsAndEnchantingPointsAIModal
              t={t}
              icon="SUN"
              iconColor="#8bdb00"
              generationText={t('card:Generating enchantments')}
              thematicAnalyzed={thematicAnalyzed}
              insight="enchantements"
              isOpen={enchantementsModal}
              numberOfMentions={thematicMentionCount}
              title={`${thematicAnalyzed.thematic} ${
                thematicAnalyzed.subThematic ? `> ${thematicAnalyzed.subThematic}` : ''
              } ${thematicAnalyzed.subSubThematic ? `> ${thematicAnalyzed.subSubThematic}` : ''}`}
              titleSecondPart=""
              className=""
              toggle={() => setEnchantementsModal(!enchantementsModal)}
              modal={enchantementsModal}
              projectId={projectId}
              range={range}
              handleFetchClick={handleFetchClick}
              shouldFetch={shouldFetch}
              setShouldFetch={setShouldFetch}
              queryFilters={getQueryFilters()}
            />
          )}
        </IconCell>
        <IconCell>
          <ModalLink
            id={`${modalTargetId}_irritants`}
            onMouseEnter={() => handleMouseEnter(`${modalTargetId}_irritants`)}
            onClick={() => {
              handleFetchClick(thematic);
              isAiAvailable && setIrritantsModal(!irritantsModal);
            }}
          >
            <Icon
              className={!isAiAvailable ? 'disabledIcon' : undefined}
              icon="INTERFACE_IRRITANTS"
              size={28}
              color="#000"
            />
          </ModalLink>
          {irritantsModal && dataId === thematic?.thematicsOverviewDetails?.name && (
            <IrritantsAndEnchantingPointsAIModal
              t={t}
              icon="INTERFACE_IRRITANTS"
              iconColor="#000"
              generationText={t('card:Generating irritants')}
              thematicAnalyzed={thematicAnalyzed}
              insight="irritants"
              isOpen={irritantsModal}
              numberOfMentions={thematicMentionCount}
              title={`${thematicAnalyzed.thematic} ${
                thematicAnalyzed.subThematic ? `> ${thematicAnalyzed.subThematic}` : ''
              } ${thematicAnalyzed.subSubThematic ? `> ${thematicAnalyzed.subSubThematic}` : ''}`}
              titleSecondPart=""
              className=""
              toggle={() => setIrritantsModal(!irritantsModal)}
              modal={irritantsModal}
              projectId={projectId}
              range={range}
              handleFetchClick={handleFetchClick}
              shouldFetch={shouldFetch}
              setShouldFetch={setShouldFetch}
              queryFilters={getQueryFilters()}
            />
          )}
        </IconCell>
      </tr>
    </>
  );
};

export default IrritantsAndEnchantingPointsAIRow;
